import React from 'react';
import Card from 'react-bootstrap/Card';

const EnfoqueEstrategico = () => {
  const cardStyle = {
    backgroundColor: 'rgba(255, 255, 255, 0.22)', // fondo blanco semitransparente
    color: 'black',
    textAlign: 'justify',
  };

  const titleStyle = {
    color: 'red',
    textAlign: 'center',
    margin: 0,
  };

  return (
    <div className="container mt-5">
      <div className="row g-4">
        <div className="col-12 col-md-6">
          <Card className="h-100 animate-fade-in-up shadow-sm" style={cardStyle}>
            <Card.Header style={{ backgroundColor: 'transparent', borderBottom: 'none' }}>
              <h5 style={titleStyle}>MISIÓN</h5>
            </Card.Header>
            <Card.Body>
              <Card.Text>
                Nuestra misión es proporcionar soluciones integrales y de alta calidad en equipos contra incendios y bombas de agua, 
                con el objetivo de proteger vidas, propiedades y el medio ambiente. Nos comprometemos a ofrecer productos innovadores 
                y servicios excepcionales que garanticen la seguridad y eficiencia en la prevención y control de incendios, así como en el suministro de agua.
                Trabajamos con pasión y responsabilidad para crear un entorno más seguro y resiliente para nuestras comunidades, promoviendo
                la conciencia, la preparación ante emergencias y el uso sostenible del recurso hídrico.
              </Card.Text>
            </Card.Body>
          </Card>
        </div>

        <div className="col-12 col-md-6">
          <Card className="h-100 animate-fade-in-up shadow-sm" style={cardStyle}>
            <Card.Header style={{ backgroundColor: 'transparent', borderBottom: 'none' }}>
              <h5 style={titleStyle}>VISIÓN</h5>
            </Card.Header>
            <Card.Body>
              <Card.Text>
                Nuestra visión es ser reconocidos como líderes en el mercado de equipos contra incendios y bombas de agua, brindando 
                soluciones innovadoras y de alta calidad que superen las expectativas de nuestros clientes. Aspiramos a establecer un estándar de excelencia en seguridad y eficiencia, fomentando una cultura de prevención y 
                respuesta rápida ante emergencias. Nos comprometemos a desarrollar tecnologías sostenibles y prácticas que contribuyan al bienestar de las comunidades y la 
                preservación del medio ambiente, consolidándonos como la opción de confianza en la protección y manejo responsable del recurso hídrico.
              </Card.Text>
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default EnfoqueEstrategico;
